import { render, staticRenderFns } from "./Workbench.vue?vue&type=template&id=7d315ea0&scoped=true&"
import script from "./Workbench.vue?vue&type=script&lang=js&"
export * from "./Workbench.vue?vue&type=script&lang=js&"
import style0 from "./Workbench.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Workbench.vue?vue&type=style&index=1&id=7d315ea0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d315ea0",
  null
  
)

export default component.exports